export default __webpack_public_path__ + "static/media/icon_error.66cef346.svg";